import { Head } from '@inertiajs/react'

// Meta tags (og:*, twitter:*, canonical, description, JSON-LD) are rendered
// server-side in app/views/layouts/application.html.erb from @seo. That makes
// them reliable for crawlers independent of SSR/JS state. Inertia's <Head>
// does not de-dupe against server-rendered tags, so emitting them here would
// ship duplicates AND go stale after SPA navigation.
//
// This component stays in the tree to (a) update the browser tab title during
// SPA navigation, and (b) let pages inject extras via `children` (e.g. noindex
// on preview pages).
export function SeoHead({ seo, children }) {
  if (!seo) return children ? <Head>{children}</Head> : null

  return (
    <Head>
      <title>{seo.title}</title>
      {children}
    </Head>
  )
}
